import React, { ReactNode, MouseEventHandler } from "react";
import "./style.css";

interface ColProps {
  md?: number;
  lg?: number;
  sm?: number;
  xl?: number;
  xs?: number;
  col?: number;
  children?: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const Col: React.FC<ColProps> = ({
  md,
  lg,
  sm,
  xl,
  xs,
  col,
  children,
  className = "",
  onClick,
}) => {
  return (
    <div
      className={`col-${col} col-lg-${lg} col-md-${md} col-xs-${xs} mb-2 col-sm-${sm} col-xl-${xl} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

interface RowProps {
  children: ReactNode;
  className?: string;
  gap?: number;
  justify?: string;
}

export const Row: React.FC<RowProps> = ({
  children,
  className = "",
  gap,
  justify,
}) => {
  return (
    <div
      className={`row ${gap ? `gap-${gap}` : ""} ${className} ${
        justify ? `justify-${justify}` : ""
      }`}
    >
      {children}
    </div>
  );
};

interface ContainerProps {
  children?: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className = "",
  onClick,
}) => {
  return (
    <section className="py-5">
      <div
        className={`container mx-auto overflow-hidden pb-3 ${className}`}
        onClick={onClick}
      >
        {children}
      </div>
    </section>
  );
};
